import React from 'react';

const STYLE = {
  paid: ['PO: Paid', 'bg-emerald-100 text-emerald-800 border-emerald-200'],
  credit: ['PO: Credit', 'bg-sky-100 text-sky-800 border-sky-200'],
};

// PO payment terms (Paid / Credit); older POs without a choice show "Not set".
export const PaymentTypeBadge = ({ type, testId }) => {
  const [label, cls] = STYLE[type] || ['Not set', 'bg-slate-100 text-slate-500 border-slate-200'];
  return (
    <span className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${cls}`} data-testid={testId}>
      {label}
    </span>
  );
};

export default PaymentTypeBadge;
